import {
  useCuentaContableEmpresaCompra,
  useCuentaContableEmpresaIvaCompra,
  useCuentaContableEmpresaIvaVenta,
  useCuentaContableEmpresaRetencionCompra,
  useCuentaContableEmpresaRetencionVenta,
  useCuentaContableEmpresaVenta,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaCliente,
  useCuentaContableCuentaCompra,
  useCuentaContableCuentaIvaCompra,
  useCuentaContableCuentaIvaVenta,
  useCuentaContableCuentaPrestamoConcedido,
  useCuentaContableCuentaPrestamoRecibido,
  useCuentaContableCuentaProveedor,
  useCuentaContableCuentaRetencionCompra,
  useCuentaContableCuentaRetencionVenta,
  useCuentaContableCuentaVenta,
} from "api/CuentaContable_Cuenta.hook"
import { putEmpresaConfiguracionPrestamo } from "api/Empresa.service"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import Button from "common/components/Button/Button"
import ButtonsToggle from "common/components/ButtonsToggle"
import entities from "common/constants/entities"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import useCuentasContablesConfiguracion from "features/Tesoreria/hooks/useCuentasContablesConfiguracion"
import { userSelector } from "features/User/redux/slices/userSlice"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { TarjetaConfiguracion } from "../../components/TarjetaConfiguracion"
import "./CuentasContables.scss"
import PrestamoConcedidoConfiguracion from "./PrestamoConcedidoConfiguracion"
import PrestamoRecibidoConfiguracion from "./PrestamoRecibidoConfiguracion"
import TicketConfiguracion from "./TicketsConfiguracion"
import {
  ESTADO_TIPO_PRESTAMO,
  getToggleButtons,
  obtenerIdCuentaGenerica,
} from "./constant"

const CuentasContables = () => {
  const { t } = useTranslation()
  const { getCuentaContablePorDefecto } = useCuentasContables()

  const [tabSelected, setTabSelected] = useState(
    ESTADO_TIPO_PRESTAMO(t)[1].value
  )
  const {
    empresaActiva: {
      configuracion: {
        digitosCuentasContables: initialNumeroDeCifras,
        configuracionesPrestamo,
      },
      fetching: fetchingDigitosCuentasContables,
    },
  } = useSelector(userSelector)
  const configuracionPrestamoConcedido = configuracionesPrestamo?.find(
    (configuracion: $TSMigrationFixMe) => configuracion?.tipoPrestamo === 1
  )
  const configuracionPrestamoRecibido = configuracionesPrestamo?.find(
    (configuracion: $TSMigrationFixMe) => configuracion?.tipoPrestamo === 2
  )

  const [prestamoCheckboxState, setPrestamoCheckboxState] = useState({
    firstCheckbox: false,
    secondCheckbox: false,
  })
  const handlePrestamosCheckbox = () => {
    function handleFirstCheckbox() {
      setPrestamoCheckboxState({
        firstCheckbox: !prestamoCheckboxState.firstCheckbox,
        secondCheckbox: false,
      })
    }
    function handleSecondCheckbox() {
      setPrestamoCheckboxState({
        ...prestamoCheckboxState,
        secondCheckbox: !prestamoCheckboxState.secondCheckbox,
      })
    }
    return {
      prestamoCheckboxState,
      handleFirstCheckbox,
      handleSecondCheckbox,
    }
  }

  const {
    cuentasContablesEmpresas: listaDeCuentasClientesBase,
    cuentasContablesEmpresasIsLoading: listaDeCuentasClientesBaseIsLoadingBase,
  } = useCuentaContableCuentaCliente()
  const initialPorDefectoBaseClientes = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.CLIENTE
  )
  const initialPorDefectoClientes = listaDeCuentasClientesBase?.find(
    (element) =>
      element?.cuentaContableEmpresaBase?.id === initialPorDefectoBaseClientes
  )

  const {
    cuentasContablesEmpresas: listaDeCuentasProveedoresBase,
    cuentasContablesEmpresasIsLoading:
      listaDeCuentasProveedoresBaseIsLoadingBase,
  } = useCuentaContableCuentaProveedor()

  const initialPorDefectoBaseProveedores = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.PROVEEDOR
  )
  const initialPorDefectoProveedores = listaDeCuentasProveedoresBase?.find(
    (element) =>
      element?.cuentaContableEmpresaBase?.id ===
      initialPorDefectoBaseProveedores
  )

  const { cuentasContablesEmpresas: listaDeCuentasVentasBase } =
    useCuentaContableCuentaVenta()
  const {
    cuentasContablesEmpresas: listaDeCuentasVentas,
    cuentasContablesEmpresasIsLoading: listaDeCuentasVentasIsLoadingBase,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasVentas,
  } = useCuentaContableEmpresaVenta()

  const initialPorDefectoVentas = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA
  )

  const { cuentasContablesEmpresas: listaDeCuentasComprasBase } =
    useCuentaContableCuentaCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasCompras,
    cuentasContablesEmpresasIsLoading: listaDeCuentasComprasIsLoadingBase,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasCompras,
  } = useCuentaContableEmpresaCompra()

  const initialPorDefectoCompras = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.COMPRA
  )

  const { cuentasContablesEmpresas: listaDeCuentasImpuestosVentasBase } =
    useCuentaContableCuentaIvaVenta()
  const {
    cuentasContablesEmpresas: listaDeCuentasImpuestosVentas,
    cuentasContablesEmpresasIsLoading:
      listaDeCuentasImpuestosVentaIsLoadingBase,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasImpuestosVentas,
  } = useCuentaContableEmpresaIvaVenta()
  const initialPorDefectoImpuestosVentas = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_VENTA
  )

  const { cuentasContablesEmpresas: listaDeCuentasImpuestosComprasBase } =
    useCuentaContableCuentaIvaCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasImpuestosCompras,
    cuentasContablesEmpresasIsLoading:
      listaDeCuentasImpuestosComprasIsLoadingBase,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasImpuestosCompras,
  } = useCuentaContableEmpresaIvaCompra()
  const initialPorDefectoImpuestosCompras = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.IVA_COMPRA
  )

  const { cuentasContablesEmpresas: listaDeCuentasRetencionesVentasBase } =
    useCuentaContableCuentaRetencionVenta()
  const {
    cuentasContablesEmpresas: listaDeCuentasRetencionesVentas,
    cuentasContablesEmpresasIsLoading:
      listaDeCuentasRetencionesVentasIsLoadingBase,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasRetencionesVentas,
  } = useCuentaContableEmpresaRetencionVenta()
  const initialPorDefectoRetencionesVentas = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.RETENCION_VENTA
  )

  const { cuentasContablesEmpresas: listaDeCuentasRetencionesComprasBase } =
    useCuentaContableCuentaRetencionCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasRetencionesCompras,
    cuentasContablesEmpresasIsLoading:
      listaDeCuentasRetencionesComprasIsLoadingBase,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasRetencionesCompras,
  } = useCuentaContableEmpresaRetencionCompra()
  const initialPorDefectoRetencionesCompras = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.RETENCION_COMPRA
  )

  const initialPorDefectoTicketReembolso = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.TICKET_REEMBOLSO
  )

  useEffect(() => {
    setPrestamoCheckboxState({
      firstCheckbox:
        tabSelected === 1
          ? configuracionPrestamoConcedido?.crearCuentaContableAutomatica
          : tabSelected === 2
          ? configuracionPrestamoRecibido?.crearCuentaContableAutomatica
          : false,
      secondCheckbox:
        tabSelected === 1
          ? configuracionPrestamoConcedido?.asignarMismaCuentaContablePorContacto
          : tabSelected === 2
          ? configuracionPrestamoRecibido?.asignarMismaCuentaContablePorContacto
          : false,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabSelected])

  const handleTab = useCallback((value: $TSMigrationFixMe) => {
    setTabSelected(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onRenderButtonsOptions = useMemo(() => {
    return getToggleButtons(handleTab, t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleTab])

  const { cuentasContablesEmpresas: cuentasPrestamoBaseConcedido } =
    useCuentaContableCuentaPrestamoConcedido()

  const initialPorDefectoPrestamoConcedido = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_CONCEDIDO
  )
  const initialPorDefectoPrestamoConcedidoBase =
    cuentasPrestamoBaseConcedido?.find(({ cuentaContableEmpresaBase }) => {
      return (
        cuentaContableEmpresaBase?.id === initialPorDefectoPrestamoConcedido
      )
    })?.id

  const initialPorDefectoPrestamoInteresConcedido = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_CONCEDIDO
  )
  const initialPorDefectoPrestamoInteresRecibido = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.INTERES_PRESTAMO_RECIBIDO
  )
  const initialPorDefectoPrestamoComisionAperturaConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_CONCEDIDO
    )
  const initialPorDefectoPrestamoComisionEstudioConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_CONCEDIDO
    )
  const initialPorDefectoPrestamoComisionDisposicionConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_CONCEDIDO
    )
  const initialPorDefectoPrestamoComisionCorretajeConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_CONCEDIDO
    )
  const initialPorDefectoPrestamoComisionOtrasConcedido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_CONCEDIDO
    )

  const { cuentasContablesEmpresas: cuentasPrestamoBaseRecibido } =
    useCuentaContableCuentaPrestamoRecibido()
  const initialPorDefectoPrestamoRecibido = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.PRESTAMO_RECIBIDO
  )
  const initialPorDefectoPrestamoRecibidoBase =
    cuentasPrestamoBaseRecibido?.find(({ cuentaContableEmpresaBase }) => {
      return cuentaContableEmpresaBase?.id === initialPorDefectoPrestamoRecibido
    })?.id

  const initialPorDefectoPrestamoComisionAperturaRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_APERTURA_PRESTAMO_RECIBIDO
    )
  const initialPorDefectoPrestamoComisionEstudioRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_ESTUDIO_PRESTAMO_RECIBIDO
    )
  const initialPorDefectoPrestamoComisionDisposicionRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_DISPOSICION_PRESTAMO_RECIBIDO
    )
  const initialPorDefectoPrestamoComisionCorretajeRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_CORRETAJE_PRESTAMO_RECIBIDO
    )
  const initialPorDefectoPrestamoComisionOtrasRecibido =
    getCuentaContablePorDefecto(
      CATEGORIA_CUENTA_CONTABLE_ENUM.COMISION_OTRA_PRESTAMO_RECIBIDO
    )

  const {
    savingChanges,
    newNumeroDeCifras,
    newPorDefectoClientes,
    newPorDefectoProveedores,
    newPorDefectoVentas,
    newPorDefectoCompras,
    newPorDefectoImpuestosCompras,
    newPorDefectoImpuestosVentas,
    newPorDefectoRetencionesCompras,
    newPorDefectoRetencionesVentas,
    newPorDefectoPrestamoConcedido,
    newPorDefectoPrestamoRecibido,
    newPorDefectoPrestamoInteresConcedido,
    newPorDefectoPrestamoInteresRecibido,
    newPorDefectoPrestamoComisionAperturaConcedido,
    newPorDefectoPrestamoComisionEstudioConcedido,
    newPorDefectoPrestamoComisionDisposicionConcedido,
    newPorDefectoPrestamoComisionCorretajeConcedido,
    newPorDefectoPrestamoComisionOtrasConcedido,
    newPorDefectoPrestamoComisionAperturaRecibido,
    newPorDefectoPrestamoComisionEstudioRecibido,
    newPorDefectoPrestamoComisionDisposicionRecibido,
    newPorDefectoPrestamoComisionCorretajeRecibido,
    newPorDefectoPrestamoComisionOtrasRecibido,
    newPorDefectoTicketReembolso,
    handleSetNumeroDeCifras,
    handleSetPorDefectoClientes,
    handleSetPorDefectoProveedores,
    handleSetPorDefectoVentas,
    handleSetPorDefectoCompras,
    handleSetPorDefectoImpuestosVentas,
    handleSetPorDefectoImpuestosCompras,
    handleSetPorDefectoRetencionesVentas,
    handleSetPorDefectoRetencionesCompras,
    handleSetPorDefectoPrestamoConcedido,
    handleSetPorDefectoPrestamoRecibido,
    handleSetPorDefectoInteresesPrestamoConcedido,
    handleSetPorDefectoInteresesPrestamoRecibido,
    handleSetPorDefectoPrestamoComAperturaConcedido,
    handleSetPorDefectoPrestamoComEstudioConcedido,
    handleSetPorDefectoPrestamoComDisposicionConcedido,
    handleSetPorDefectoPrestamoComCorretajeConcedido,
    handleSetPorDefectoPrestamoComOtrasConcedido,
    handleSetPorDefectoPrestamoComAperturaRecibido,
    handleSetPorDefectoPrestamoComEstudioRecibido,
    handleSetPorDefectoPrestamoComDisposicionRecibido,
    handleSetPorDefectoPrestamoComCorretajeRecibido,
    handleSetPorDefectoPrestamoComOtrasRecibido,
    handleSetPorDefectoTicketReembolso,
    actualizarConfiguracion,
  } = useCuentasContablesConfiguracion({
    initialNumeroDeCifras,
    initialPorDefectoClientes,
    initialPorDefectoProveedores,
    initialPorDefectoVentas,
    initialPorDefectoCompras,
    initialPorDefectoImpuestosCompras,
    initialPorDefectoImpuestosVentas,
    initialPorDefectoRetencionesCompras,
    initialPorDefectoRetencionesVentas,
    initialPorDefectoPrestamoConcedido: prestamoCheckboxState.firstCheckbox
      ? initialPorDefectoPrestamoConcedidoBase
      : initialPorDefectoPrestamoConcedido,
    initialPorDefectoPrestamoRecibido: prestamoCheckboxState.firstCheckbox
      ? initialPorDefectoPrestamoRecibidoBase
      : initialPorDefectoPrestamoRecibido,
    initialPorDefectoPrestamoInteresConcedido,
    initialPorDefectoPrestamoInteresRecibido,
    initialPorDefectoPrestamoComisionAperturaConcedido,
    initialPorDefectoPrestamoComisionEstudioConcedido,
    initialPorDefectoPrestamoComisionDisposicionConcedido,
    initialPorDefectoPrestamoComisionCorretajeConcedido,
    initialPorDefectoPrestamoComisionOtrasConcedido,
    initialPorDefectoPrestamoComisionAperturaRecibido,
    initialPorDefectoPrestamoComisionEstudioRecibido,
    initialPorDefectoPrestamoComisionDisposicionRecibido,
    initialPorDefectoPrestamoComisionCorretajeRecibido,
    initialPorDefectoPrestamoComisionOtrasRecibido,
    initialPorDefectoTicketReembolso,
  })

  const prepareCuentasContablesPutPayload = () => ({
    cuentasContables: [
      {
        categoria: entities.cliente,
        cuentaContableId:
          newPorDefectoClientes &&
          obtenerIdCuentaGenerica(
            newPorDefectoClientes,
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            listaDeCuentasClientesBase
          ),
      },
      {
        categoria: entities.proveedor,
        cuentaContableId:
          newPorDefectoProveedores &&
          obtenerIdCuentaGenerica(
            newPorDefectoProveedores,
            // @ts-expect-error TS(2345): Argument of type 'CuentaContableCuentaReadingDtoPr...
            listaDeCuentasProveedoresBase
          ),
      },
      {
        categoria: entities.venta,
        cuentaContableId: newPorDefectoVentas,
      },
      {
        categoria: entities.compra,
        cuentaContableId: newPorDefectoCompras,
      },
      {
        categoria: entities.prestamoConcedido,
        cuentaContableId:
          newPorDefectoPrestamoConcedido &&
          typeof newPorDefectoPrestamoConcedido === "string"
            ? newPorDefectoPrestamoConcedido
            : obtenerIdCuentaGenerica(
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param...
                newPorDefectoPrestamoConcedido,
                cuentasPrestamoBaseConcedido
              ),
      },
      {
        categoria: entities.interesPrestamoConcedido,
        cuentaContableId: newPorDefectoPrestamoInteresConcedido,
      },
      {
        categoria: entities.comisionAperturaPrestamoConcedido,
        cuentaContableId: newPorDefectoPrestamoComisionAperturaConcedido,
      },
      {
        categoria: entities.comisionEstudioPrestamoConcedido,
        cuentaContableId: newPorDefectoPrestamoComisionEstudioConcedido,
      },
      {
        categoria: entities.prestamoRecibido,
        cuentaContableId:
          newPorDefectoPrestamoRecibido &&
          typeof newPorDefectoPrestamoRecibido === "string"
            ? newPorDefectoPrestamoRecibido
            : obtenerIdCuentaGenerica(
                // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param...
                newPorDefectoPrestamoRecibido,
                cuentasPrestamoBaseRecibido
              ),
      },
      {
        categoria: entities.interesPrestamoRecibido,
        cuentaContableId: newPorDefectoPrestamoInteresRecibido,
      },
      {
        categoria: entities.ivaCompra,
        cuentaContableId: newPorDefectoImpuestosCompras,
      },
      {
        categoria: entities.ivaVenta,
        cuentaContableId: newPorDefectoImpuestosVentas,
      },
      {
        categoria: entities.retencionCompra,
        cuentaContableId: newPorDefectoRetencionesCompras,
      },
      {
        categoria: entities.retencionVenta,
        cuentaContableId: newPorDefectoRetencionesVentas,
      },
      {
        categoria: entities.comisionDisposicionPrestamoConcedido,
        cuentaContableId: newPorDefectoPrestamoComisionDisposicionConcedido,
      },
      {
        categoria: entities.comisionCorretajePrestamoConcedido,
        cuentaContableId: newPorDefectoPrestamoComisionCorretajeConcedido,
      },
      {
        categoria: entities.comisionOtraPrestamoConcedido,
        cuentaContableId: newPorDefectoPrestamoComisionOtrasConcedido,
      },
      {
        categoria: entities.comisionAperturaPrestamoRecibido,
        cuentaContableId: newPorDefectoPrestamoComisionAperturaRecibido,
      },
      {
        categoria: entities.comisionEstudioPrestamoRecibido,
        cuentaContableId: newPorDefectoPrestamoComisionEstudioRecibido,
      },
      {
        categoria: entities.comisionDisposicionPrestamoRecibido,
        cuentaContableId: newPorDefectoPrestamoComisionDisposicionRecibido,
      },
      {
        categoria: entities.comisionCorretajePrestamoRecibido,
        cuentaContableId: newPorDefectoPrestamoComisionCorretajeRecibido,
      },
      {
        categoria: entities.comisionOtraPrestamoRecibido,
        cuentaContableId: newPorDefectoPrestamoComisionOtrasRecibido,
      },
      {
        categoria: entities.ticketReembolso,
        cuentaContableId: newPorDefectoTicketReembolso,
      },
    ].filter(({ cuentaContableId }) => cuentaContableId),
  })

  const compareAndsaveAllChanges = () => {
    putEmpresaConfiguracionPrestamo({
      configuracionesPrestamo: [
        {
          crearCuentaContableAutomatica: prestamoCheckboxState.firstCheckbox,
          asignarMismaCuentaContablePorContacto:
            prestamoCheckboxState.secondCheckbox,
          // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'TipoPrest...
          tipoPrestamo: tabSelected,
        },
      ],
    })
    const payload = prepareCuentasContablesPutPayload()
    actualizarConfiguracion(payload)
  }

  return (
    <div className='cuentas-contables'>
      <div className='container'>
        <div className='cuentas-contables__titulo'>
          {t("cuentasContables.title")}
        </div>

        <TarjetaConfiguracion
          header={`${t("cuentasContables.headerNumFigures")}`}
          descripcion={`${t("cuentasContables.textNumFigures")}`}
          campos={[
            {
              titulo: `${t("cuentasContables.labelNumFigures")}`,
              value: newNumeroDeCifras || initialNumeroDeCifras,
              loadingData: fetchingDigitosCuentasContables,
              handleSetData: handleSetNumeroDeCifras,
              opciones: [
                { label: "5", value: 5 },
                { label: "6", value: 6 },
                { label: "7", value: 7 },
                { label: "8", value: 8 },
                { label: "9", value: 9 },
                { label: "10", value: 10 },
                { label: "11", value: 11 },
                { label: "12", value: 12 },
                { label: "13", value: 13 },
                { label: "14", value: 14 },
                { label: "15", value: 15 },
              ],
            },
          ]}
        />

        <TarjetaConfiguracion
          header={`${t("cuentasContables.headerClient")}`}
          descripcion={`${t("cuentasContables.textClient")}`}
          cuentas={[
            {
              titulo: `${t("cuentasContables.labelClient")}`,
              value: newPorDefectoClientes || initialPorDefectoClientes?.id,
              listaDeCuentas: listaDeCuentasClientesBase,
              loadingCuentas:
                listaDeCuentasClientesBaseIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoClientes,
              withCreateCuenta: false,
            },
            {
              titulo: `${t("cuentasContables.labelProvince")}`,
              value:
                newPorDefectoProveedores || initialPorDefectoProveedores?.id,
              listaDeCuentas: listaDeCuentasProveedoresBase,
              loadingCuentas:
                listaDeCuentasProveedoresBaseIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoProveedores,
              withCreateCuenta: false,
            },
          ]}
        />

        <TarjetaConfiguracion
          header={`${t("cuentasContables.headerSalesPurchases")}`}
          descripcion={`${t("cuentasContables.textSalesPurchases")}`}
          cuentas={[
            {
              titulo: `${t("cuentasContables.labelSales")}`,
              value: newPorDefectoVentas || initialPorDefectoVentas,
              listaDeCuentas: listaDeCuentasVentas,
              listaDeCuentasBase: listaDeCuentasVentasBase,
              cuentaPorDefecto: initialPorDefectoVentas,
              loadingCuentas:
                listaDeCuentasVentasIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoVentas,
              withCreateCuenta: true,
              refreshFetchData: refresListaDeCuentasVentas,
            },
            {
              titulo: `${t("cuentasContables.labelPurchases")}`,
              value: newPorDefectoCompras || initialPorDefectoCompras,
              listaDeCuentas: listaDeCuentasCompras,
              listaDeCuentasBase: listaDeCuentasComprasBase,
              cuentaPorDefecto: initialPorDefectoCompras,
              loadingCuentas:
                listaDeCuentasComprasIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoCompras,
              withCreateCuenta: true,
              refreshFetchData: refresListaDeCuentasCompras,
            },
          ]}
        />

        <TarjetaConfiguracion
          header={`${t("cuentasContables.taxes")}`}
          descripcion={`${t("cuentasContables.textSalesPurchases")}`}
          cuentas={[
            {
              titulo: `${t("cuentasContables.labelSales")}`,
              value:
                newPorDefectoImpuestosVentas ||
                initialPorDefectoImpuestosVentas,
              listaDeCuentas: listaDeCuentasImpuestosVentas,
              listaDeCuentasBase: listaDeCuentasImpuestosVentasBase,
              cuentaPorDefecto: initialPorDefectoImpuestosVentas,
              loadingCuentas:
                listaDeCuentasImpuestosVentaIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoImpuestosVentas,
              withCreateCuenta: true,
              refreshFetchData: refresListaDeCuentasImpuestosVentas,
            },
            {
              titulo: `${t("cuentasContables.labelPurchases")}`,
              value:
                newPorDefectoImpuestosCompras ||
                initialPorDefectoImpuestosCompras,
              listaDeCuentas: listaDeCuentasImpuestosCompras,
              listaDeCuentasBase: listaDeCuentasImpuestosComprasBase,
              cuentaPorDefecto: initialPorDefectoImpuestosCompras,
              loadingCuentas:
                listaDeCuentasImpuestosComprasIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoImpuestosCompras,
              withCreateCuenta: true,
              refreshFetchData: refresListaDeCuentasImpuestosCompras,
            },
          ]}
        />

        <TarjetaConfiguracion
          header={`${t("cuentasContables.retentions")}`}
          descripcion={`${t("cuentasContables.textSalesPurchases")}`}
          cuentas={[
            {
              titulo: `${t("cuentasContables.labelSales")}`,
              value:
                newPorDefectoRetencionesVentas ||
                initialPorDefectoRetencionesVentas,
              listaDeCuentas: listaDeCuentasRetencionesVentas,
              listaDeCuentasBase: listaDeCuentasRetencionesVentasBase,
              cuentaPorDefecto: initialPorDefectoRetencionesVentas,
              loadingCuentas:
                listaDeCuentasRetencionesVentasIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoRetencionesVentas,
              withCreateCuenta: true,
              refreshFetchData: refresListaDeCuentasRetencionesVentas,
            },
            {
              titulo: `${t("cuentasContables.labelPurchases")}`,
              value:
                newPorDefectoRetencionesCompras ||
                initialPorDefectoRetencionesCompras,
              listaDeCuentas: listaDeCuentasRetencionesCompras,
              listaDeCuentasBase: listaDeCuentasRetencionesComprasBase,
              cuentaPorDefecto: initialPorDefectoRetencionesCompras,
              loadingCuentas:
                listaDeCuentasRetencionesComprasIsLoadingBase || savingChanges,
              handleSetData: handleSetPorDefectoRetencionesCompras,
              withCreateCuenta: true,
              refreshFetchData: refresListaDeCuentasRetencionesCompras,
            },
          ]}
        />
        <TicketConfiguracion
          initialPorDefectoTicketsReembolso={
            newPorDefectoTicketReembolso || initialPorDefectoTicketReembolso
          }
          handleSetTicketReembolso={handleSetPorDefectoTicketReembolso}
        />

        <div className='tarjeta-configuracion'>
          <div className='tw-flex tw-flex-row tw-justify-between tw-items-center'>
            <div className='tw-text-lg tw-font-medium tw-mb-4'>
              {tabSelected === 1
                ? `${t("config.loanGrantedTitle")}`
                : `${t("config.loanReceivedTitle")}`}{" "}
            </div>
            <ButtonsToggle
              headerGroupItems={onRenderButtonsOptions}
              isBlocked={false}
              tabSelected={tabSelected}
              initialValue={undefined}
              fullDisabled={undefined}
              grid={undefined}
              className='!tw-w-fit'
            />
          </div>
          <p className='mb-3'>{t("config.description")}</p>

          {tabSelected === 1 ? (
            <PrestamoConcedidoConfiguracion
              initialPorDefectoPrestamoConcedido={
                prestamoCheckboxState.firstCheckbox
                  ? newPorDefectoPrestamoConcedido ??
                    initialPorDefectoPrestamoConcedidoBase
                  : newPorDefectoPrestamoConcedido ??
                    initialPorDefectoPrestamoConcedido
              }
              handleSetPrestamo={handleSetPorDefectoPrestamoConcedido}
              initialPorDefectoPrestamoInteresConcedido={
                newPorDefectoPrestamoInteresConcedido ??
                initialPorDefectoPrestamoInteresConcedido
              }
              handleSetPrestamoInteres={
                handleSetPorDefectoInteresesPrestamoConcedido
              }
              initialPorDefectoPrestamoComisionAperturaConcedido={
                newPorDefectoPrestamoComisionAperturaConcedido ??
                initialPorDefectoPrestamoComisionAperturaConcedido
              }
              initialPorDefectoPrestamoComisionEstudioConcedido={
                newPorDefectoPrestamoComisionEstudioConcedido ??
                initialPorDefectoPrestamoComisionEstudioConcedido
              }
              initialPorDefectoPrestamoComisionDisposicionConcedido={
                newPorDefectoPrestamoComisionDisposicionConcedido ??
                initialPorDefectoPrestamoComisionDisposicionConcedido
              }
              initialPorDefectoPrestamoComisionCorretajeConcedido={
                newPorDefectoPrestamoComisionCorretajeConcedido ??
                initialPorDefectoPrestamoComisionCorretajeConcedido
              }
              initialPorDefectoPrestamoComisionOtrasConcedido={
                newPorDefectoPrestamoComisionOtrasConcedido ??
                initialPorDefectoPrestamoComisionOtrasConcedido
              }
              handleSetPrestamoApertura={
                handleSetPorDefectoPrestamoComAperturaConcedido
              }
              handleSetPrestamoEstudio={
                handleSetPorDefectoPrestamoComEstudioConcedido
              }
              handleSetPrestamoDisposicion={
                handleSetPorDefectoPrestamoComDisposicionConcedido
              }
              handleSetPrestamoCorretaje={
                handleSetPorDefectoPrestamoComCorretajeConcedido
              }
              handleSetPrestamoOtras={
                handleSetPorDefectoPrestamoComOtrasConcedido
              }
              handlePrestamosCheckbox={handlePrestamosCheckbox}
            />
          ) : (
            <PrestamoRecibidoConfiguracion
              initialPorDefectoPrestamoRecibido={
                prestamoCheckboxState.firstCheckbox
                  ? newPorDefectoPrestamoRecibido ??
                    initialPorDefectoPrestamoRecibidoBase
                  : newPorDefectoPrestamoRecibido ??
                    initialPorDefectoPrestamoRecibido
              }
              handleSetPrestamo={handleSetPorDefectoPrestamoRecibido}
              initialPorDefectoPrestamoInteresRecibido={
                newPorDefectoPrestamoInteresRecibido ??
                initialPorDefectoPrestamoInteresRecibido
              }
              handleSetPrestamoInteres={
                handleSetPorDefectoInteresesPrestamoRecibido
              }
              initialPorDefectoPrestamoComisionAperturaRecibido={
                newPorDefectoPrestamoComisionAperturaRecibido ??
                initialPorDefectoPrestamoComisionAperturaRecibido
              }
              initialPorDefectoPrestamoComisionEstudioRecibido={
                newPorDefectoPrestamoComisionEstudioRecibido ??
                initialPorDefectoPrestamoComisionEstudioRecibido
              }
              initialPorDefectoPrestamoComisionDisposicionRecibido={
                newPorDefectoPrestamoComisionDisposicionRecibido ??
                initialPorDefectoPrestamoComisionDisposicionRecibido
              }
              initialPorDefectoPrestamoComisionCorretajeRecibido={
                newPorDefectoPrestamoComisionCorretajeRecibido ??
                initialPorDefectoPrestamoComisionCorretajeRecibido
              }
              initialPorDefectoPrestamoComisionOtrasRecibido={
                newPorDefectoPrestamoComisionOtrasRecibido ??
                initialPorDefectoPrestamoComisionOtrasRecibido
              }
              handleSetPrestamoApertura={
                handleSetPorDefectoPrestamoComAperturaRecibido
              }
              handleSetPrestamoEstudio={
                handleSetPorDefectoPrestamoComEstudioRecibido
              }
              handleSetPrestamoDisposicion={
                handleSetPorDefectoPrestamoComDisposicionRecibido
              }
              handleSetPrestamoCorretaje={
                handleSetPorDefectoPrestamoComCorretajeRecibido
              }
              handleSetPrestamoOtras={
                handleSetPorDefectoPrestamoComOtrasRecibido
              }
              handlePrestamosCheckbox={handlePrestamosCheckbox}
            />
          )}
        </div>
        <div className='float-right tw-pb-5'>
          <Button
            className='!tw-bg-primary'
            loading={savingChanges}
            disabled={savingChanges}
            onClick={compareAndsaveAllChanges}
          >
            {t("cuentasContables.saveButton")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CuentasContables
